import { ErrorMessage } from '@hookform/error-message'
import { Checkbox, Flex, Typography, Form, Tooltip } from 'antd'
import { CheckboxChangeEvent } from 'antd/es/checkbox'
import { Controller } from 'react-hook-form'
import { colorBorderDisabled } from 'src/app/themes/primaryThemeDefault'
import { InforCircle } from 'src/assets/icons'
import { useState } from 'react'
import './index.scss'
import CustomSelect from 'src/app/shared/components/common/select'
interface IProps {
  title: string
  checkboxTitle: string
  tooltipTitle: string
  placeholder: string
  options: any[]
  checkboxName: string
  selectName: string
  defaultSelectedValue: any[]
  defaultCheckboxValue: boolean
  control: any
  errors: any
  clearErrors: any
  trigger: any
  setValue: any
  onSelectChange?: any
  onCheckboxChange?: any
  onSelectBlur?: any
  loading?: boolean
}
const SelectCpn = (props: IProps) => {
  const {
    title,
    checkboxTitle,
    tooltipTitle,
    placeholder,
    options,
    checkboxName,
    selectName,
    defaultSelectedValue,
    defaultCheckboxValue,
    control,
    errors,
    clearErrors,
    trigger,
    setValue,
    onSelectChange,
    onCheckboxChange,
    onSelectBlur,
    loading,
  } = props

  const [isDisabled, setIsDisabled] = useState(defaultCheckboxValue)
  const filterOption = (input: string, option?: any) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())

  const handleOnCheckboxChange = (e: any, field: any) => {
    setIsDisabled(e.target.checked)
    if (e.target.checked) {
      clearErrors(selectName)
      setValue(selectName, [])
    } else {
      trigger(selectName)
    }
    field.onChange(e)
    onCheckboxChange && onCheckboxChange(e)
  }

  return (
    <Flex vertical>
      <Form.Item label={title} className='isRequired label16' style={{ height: 0, margin: 0, flex: 1 }} />
      <Flex
        align='flex-start'
        justify='space-between'
        style={{ border: `1px solid ${colorBorderDisabled}`, padding: '20px', borderRadius: '16px', marginBottom: 24 }}
      >
        <Flex align='center' style={{ minWidth: 150, marginTop: 10 }}>
          <Controller
            name={checkboxName}
            control={control}
            render={({ field }) => (
              <Checkbox
                {...field}
                checked={field.value}
                onChange={(e: CheckboxChangeEvent) => {
                  handleOnCheckboxChange(e, field)
                }}
                defaultChecked={defaultCheckboxValue}
              >
                {checkboxTitle}
              </Checkbox>
            )}
          />
          <Tooltip placement='bottom' title={tooltipTitle} style={{ padding: '8px 12px', color: 'red' }}>
            <InforCircle />
          </Tooltip>
        </Flex>
        <Flex vertical style={{ width: '90%' }}>
          <Controller
            name={selectName}
            control={control}
            disabled={isDisabled}
            render={({ field, fieldState }) => (
              <CustomSelect
                {...field}
                style={{ width: '100%' }}
                maxTagCount='responsive'
                mode='multiple'
                options={loading ? [] : options}
                status={fieldState.error ? 'error' : ''}
                placeholder={placeholder}
                defaultValue={defaultSelectedValue}
                onChange={(e) => {
                  field.onChange(e)
                  onSelectChange && onSelectChange(e)
                }}
                onSelect={() => {
                  trigger(selectName)
                  onSelectBlur && onSelectBlur()
                }}
                onDeselect={() => {
                  trigger(selectName)
                  onSelectBlur && onSelectBlur()
                }}
                maxTagPlaceholder={(omittedValues) => (
                  <Tooltip title={omittedValues.map(({ label }) => label).join(', ')}>
                    <span>+{omittedValues?.length}</span>
                  </Tooltip>
                )}
                showSearch
                filterOption={filterOption}
                disabled={isDisabled}
                onBlur={onSelectBlur}
                loading={loading}
              />
            )}
          />
          <Typography className='error-message'>
            <ErrorMessage errors={errors} name={selectName} />
          </Typography>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default SelectCpn
